module.exports = __webpack_public_path__ + "img/pg2.80cd0b52.png";